export interface Headers {
  [key: string]: string;
}

const local = {
  headers: {
    // BE sends 404\405 if this header is not presented :dich:
    'Content-Type': 'application/json',
  },
  apiUrl: 'https://plarium.com/services/api/',
  systemApiUrl: '/',
  userToken: null as undefined | null | string,
  baseUrl: '/',
};

export function setHeaders(newHeaders: Headers) {
  Object.assign(local.headers, newHeaders);
}

export function getHeaders() {
  return local.headers;
}

export function setUserToken(token?: string) {
  local.userToken = token;
}

export function getBaseUrl() {
  return local.baseUrl;
}

// @todo no setter! has to be set from config!
export function getSystemApiUrl() {
  return local.systemApiUrl;
}

export function setSystemApiUrl(url: string) {
  return (local.systemApiUrl = url);
}

export function getApiUrl() {
  return local.apiUrl;
}

export function setApiUrl(url: string) {
  return (local.apiUrl = url);
}

export function getPrivateApiHeaders(): Record<string, string> {
  if (!local.userToken) {
    return {};
  }
  return {
    access_token: local.userToken,
    token: local.userToken,
  };
}

export function getUnauthorizedHandler() {
  return async () => console.debug('@todo UnauthorizedHandler');
}
